module.exports = __webpack_public_path__ + "img/box.5608530a.png";